import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useState} from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const TotalAccessMainApp =({})=>{
    const { t } = useTranslation();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [modalShow, setModalShow] = useState(false);
    const [deleteDeviceShow, setDeleteDeviceShow] = useState(false);
    const [showLogModal, setShowLogModal] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);


    return {
        t,
        DEV,
        permission,
        setShowLogModal,
        setModalShow,
        setDeleteDeviceShow,
        modalShow,
        showLogModal,
        deleteDeviceShow
    }
}
